import React from "react"
import style from "./Stats.module.scss"
import { diggers } from "../data/diggers"
import { DiggerIconComponent } from "./DiggerIcon"
import { getDiggerLevel } from "../service/diggerMethods"
import { Link } from "react-router-dom"

export const StatsComponent: React.FC = () => {
  const diggersSorted = diggers.sort(function (a, b) {
    return getDiggerLevel(b) - getDiggerLevel(a)
  })
  const more30 = diggersSorted.filter((digger) => getDiggerLevel(digger) >= 30)
  const more20 = diggersSorted.filter(
    (digger) => getDiggerLevel(digger) >= 20 && getDiggerLevel(digger) < 30
  )
  const more10 = diggersSorted.filter(
    (digger) => getDiggerLevel(digger) >= 10 && getDiggerLevel(digger) < 20
  )
  const beginners = diggersSorted.filter(
    (digger) => getDiggerLevel(digger) >= 0 && getDiggerLevel(digger) < 10
  )

  const diggerClickEvent = () => {
    // @ts-ignore
    ym(92771670, "reachGoal", "diggerClick")
  }

  const totalBars = diggers.reduce((totalAccumulator, digger) => {
    return (
      totalAccumulator +
      Object.entries(digger.bars).reduce((accumulator, mile) => {
        const [mileName, bars] = mile
        if (mileName != "extra") {
          return accumulator + bars.length
        }
        return accumulator
      }, 0)
    )
  }, 0)

  return (
    <div className={style.statsComponent}>
      <h2>Зал славы</h2>
      <p className={style.count}>Всего участников: {diggers.length}</p>
      <p className={style.count}>Всего баров пройдено на милях: {totalBars}</p>

      <div className={style.diggersBlock}>
        <h3>Магистры</h3>
        <div className={style.diggersBlockList}>
          {more30.map((digger, index) => (
            <Link
              key={index}
              to={digger.id ? `/diggers/${digger.id}` : "#"}
              onClick={diggerClickEvent}
            >
              <DiggerIconComponent digger={digger} />
            </Link>
          ))}
        </div>
      </div>

      <div className={style.diggersBlock}>
        <h3>Аспиранты</h3>
        <div className={style.diggersBlockList}>
          {more20.map((digger, index) => (
            <Link
              key={index}
              to={digger.id ? `/diggers/${digger.id}` : "#"}
              onClick={diggerClickEvent}
            >
              <DiggerIconComponent digger={digger} />
            </Link>
          ))}
        </div>
      </div>

      <div className={style.diggersBlock}>
        <h3>Исследователи</h3>
        <div className={style.diggersBlockList}>
          {more10.map((digger, index) => (
            <Link
              key={index}
              to={digger.id ? `/diggers/${digger.id}` : "#"}
              onClick={diggerClickEvent}
            >
              <DiggerIconComponent digger={digger} />
            </Link>
          ))}
        </div>
      </div>

      <div className={style.diggersBlock}>
        <h3>Студенты</h3>
        <div className={style.diggersBlockList}>
          {beginners.map((digger, index) => (
            <Link
              key={index}
              to={digger.id ? `/diggers/${digger.id}` : "#"}
              onClick={diggerClickEvent}
            >
              <DiggerIconComponent digger={digger} />
            </Link>
          ))}
        </div>
      </div>
    </div>
  )
}
